import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {Contract} from '../../../shared/interface/contract';
import {ContractService} from '../../../shared/services/contract.service';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {ContractOfwcaApplication} from '../../../shared/interface/contract-ofwca-application';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from '../../../shared/services/auth.service';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {OfwcasListDialogComponent} from '../../ofwcas/ofwcas-list-dialog/ofwcas-list-dialog.component';
import {
  DICT_TYPE_TEMPLATE_TYPE,
  DictService, TEMPLATE_TYPE_ANNEX_COMMISSION_ATTACHMENT, TEMPLATE_TYPE_ANNEX_OFWCA_APPLICATION, TEMPLATE_TYPE_CONTRACT,
  TEMPLATE_TYPE_OFWCA_APPLICATION, TEMPLATE_TYPE_TERMINATION
} from '../../../shared/services/dict.service';
import {Uuid} from '../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../shared/components/job-result-dialog/job-result-dialog.component';
import {TemplateService} from '../../../shared/services/template.service';
import {
  ContractInsuranceCompaniesAddDialogComponent
} from '../contract-insurance-companies-add-dialog/contract-insurance-companies-add-dialog.component';
import {
  ContractInsuranceCompaniesSelectDialogComponent
} from '../contract-insurance-companies-select-dialog/contract-insurance-companies-select-dialog.component';

@Component({
  selector: 'app-contract-ofwca-applications-list',
  templateUrl: './contract-ofwca-applications-list.component.html',
  styleUrls: ['./contract-ofwca-applications-list.component.scss']
})
export class ContractOfwcaApplicationsListComponent implements OnInit, AfterViewInit {
  @Input() contract: Contract;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  contractOfwcaApplicationsDataSource: MatTableDataSource<ContractOfwcaApplication> = new MatTableDataSource<ContractOfwcaApplication>([]);
  displayedColumns: string[] = [
    'createdAt', 'sendAt', 'signedAt', 'status', 'note', 'actions'
  ];
  userPermissions: ReplaySubject<UserPermissions>;
  updateInProgress = false;
  generatingDocument = false;

  constructor(
    private contractService: ContractService,
    private snack: MatSnackBar,
    private auth: AuthService,
    private dialog: MatDialog,
    private dictService: DictService,
    private templateService: TemplateService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.contractService.getOfwcaApplications(this.contract.uuid)
      .subscribe((response: ListResponse<ContractOfwcaApplication>) => {
        this.contractOfwcaApplicationsDataSource.data = response.items;
      });
  }

  ngAfterViewInit(): void {
    this.contractOfwcaApplicationsDataSource.paginator = this.paginator;
  }

  formChanged(
    contractOfwcaApplication: ContractOfwcaApplication,
    formData: {status: number; note: string}
  ): void {
    this.updateInProgress = true;

    this.contractService.updateOfwcaApplication(
      this.contract.uuid,
      contractOfwcaApplication.uuid,
      formData
    )
      .subscribe(() => {
        this.snack.open('Pomyślnie zakutalizowano zgłoszenie', '', {duration: 2000});
        this.contractService.getOfwcaApplications(this.contract.uuid)
          .subscribe((response: ListResponse<ContractOfwcaApplication>) => {
            this.contractOfwcaApplicationsDataSource.data = response.items;
            this.updateInProgress = false;
          });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy aktualizacji wystąpił błąd', error.status.toString(), {duration: 2000});
        this.updateInProgress = false;
      });
  }

  showOfwcaList(contractOfwcaApplication: ContractOfwcaApplication): void {
    this.dialog.open(OfwcasListDialogComponent, {
      width: '80vw',
      height: '80vh',
      data: {ofwcas: contractOfwcaApplication.ofwcas},
    });
  }

  generateApplication(): void {
    this.generatingDocument = true;
    this.dictService.getId(TEMPLATE_TYPE_OFWCA_APPLICATION, DICT_TYPE_TEMPLATE_TYPE)
      .subscribe((dictId: number) => {
        this.templateService.generate({
          type: dictId,
          contract: this.contract.uuid,
        }).subscribe((response: Uuid) => {
          const dialogRef = this.dialog.open(JobResultDialogComponent, {
            disableClose: true,
            width: '500px',
            data: {jobId: response.uuid, showProgress: false},
          });

          dialogRef.afterClosed().subscribe(() => {
            this.generatingDocument = false;
          });
        }, (error: HttpErrorResponse) => {
          this.generatingDocument = false;
          if (error.status === 404) {
            this.snack.open('Brak szablonów dla tego typu dokumentu', '', {duration: 2000});
            return;
          }

          this.snack.open('Przy generowaniu dokumentów wystąpił błąd', error.status.toString(), {duration: 2000});
        });
      });
  }

  generateAnnexApplication(): void {
    this.generateDocuments(TEMPLATE_TYPE_ANNEX_OFWCA_APPLICATION);
  }

  private generateDocuments(type: string): void {
    this.generatingDocument = true;
    this.dictService.getId(type, DICT_TYPE_TEMPLATE_TYPE)
      .subscribe((dictId: number) => {
        this.templateService.generate({
          type: dictId,
          contract: this.contract.uuid,
        }).subscribe((response: Uuid) => {
          const dialogRef = this.dialog.open(JobResultDialogComponent, {
            disableClose: true,
            width: '500px',
            data: {jobId: response.uuid, showProgress: false},
          });

          dialogRef.afterClosed().subscribe(() => {
            this.generatingDocument = false;
          });
        }, (error: HttpErrorResponse) => {
          this.generatingDocument = false;
          if (error.status === 404) {
            this.snack.open('Brak szablonów dla tego typu dokumentu', '', {duration: 2000});
            return;
          }

          this.snack.open('Przy generowaniu dokumentów wystąpił błąd', error.status.toString(), {duration: 2000});
        });
      });
  }

}
